import React, { useState } from 'react'
import { Form, Col, Row, Tab } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { IconEdit } from '../../assets/icons'

const BankTab = (props) => {

  const [ editDefault, setEditDefault ] = useState(false)

  const {t} = props
  return(
    <Tab.Pane eventKey={props.eventKey}>
      <h4>{t('locations-modal-tab-headline-bank')}</h4>

      <Row noGutters>
        <Col md={8} lg={8} xs={8}>
          <p><strong>{t('localPosts-modal-tab-edit')}</strong></p>
        </Col>
        <Col md={4} lg={4} xs={4} className={'text-right'}>
          <IconEdit 
            onClick={() => setEditDefault(!editDefault)}
          />
        </Col>
      </Row>
      <Row noGutters>
        <Col md={12} lg={12}>
          <label>{t('input-form-bank')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="bank" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.bank}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.bank}</p>
          }
        </Col>
        <Col md={6} lg={6}>
          <label>{t('input-form-iban')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="iban" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.iban}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.iban}</p>
          }
        </Col>
        <Col md={6} lg={6}>
          <label>{t('input-form-bic')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="bic" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.bic}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.bic}</p>
          }
        </Col>
        <Col md={12} lg={12}>
          <label>{t('input-form-paypal-client')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="paypalClientId" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.paypalClientId}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.paypalClientId}</p>
          }
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default (withTranslation()(BankTab))